import { render, staticRenderFns } from "./KCPushMessageHistory.vue?vue&type=template&id=511df5a2&"
import script from "./KCPushMessageHistory.vue?vue&type=script&lang=js&"
export * from "./KCPushMessageHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports